import { Link } from "react-router-dom";
import { allVideos } from "@/lib/videoData";

const stats = [
  { value: `${allVideos.length}`, suffix: "部", label: "精选影视综艺" },
  { value: "4K", suffix: "", label: "高清画质标准" },
  { value: "3", suffix: "大", label: "内容分类板块" },
  { value: "24", suffix: "h", label: "更新信息追踪" },
];

const features = [
  {
    icon: "ri-layout-grid-line",
    title: "分类细致",
    text: "电影、电视剧、综艺独立成页，地区与年份维度可组合筛选。",
  },
  {
    icon: "ri-file-text-line",
    title: "信息完整",
    text: "主演、导演、时长、集数与更新状态逐项标注，浏览即了解。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏便捷",
    text: "一键收藏感兴趣的内容，浏览器本地保存，下次打开继续追。",
  },
];

export default function SiteIntro() {
  return (
    <section className="relative mt-10 w-full overflow-hidden bg-primary-950 py-10 md:mt-16 md:py-14">
      <div className="absolute -right-24 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-accent-500/10 blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1360px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14">
          <div>
            <span className="text-[11px] font-bold tracking-[0.24em] text-accent-400">ABOUT TANGDOU</span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[32px]">
              把海量影视内容，
              <br className="hidden sm:block" />
              整理成一份好看的片单
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-300/90">
              糖豆视频成立于 2019 年，专注于影视综艺内容的整理与导览。我们不做冗长的算法推荐，而是用更清晰的结构、更完整的信息和更克制的视觉，帮你在几分钟内决定今晚看什么。
            </p>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-300/80">
              目前站内收录电影、电视剧与综艺共 {allVideos.length} 部演示内容，覆盖悬疑、家庭、科幻、古装、真人秀等多种题材，所有页面均可直接浏览体验。
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 text-xs font-bold text-foreground-950 transition-colors hover:bg-accent-400"
              >
                了解糖豆视频
                <i className="ri-arrow-right-line text-sm" />
              </Link>
              <Link
                to="/category/tv"
                className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-50/25 px-5 text-xs font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                查看热播剧集
              </Link>
            </div>
          </div>

          <div>
            <div className="grid grid-cols-2 gap-3">
              {stats.map((stat) => (
                <div key={stat.label} className="rounded-lg border border-primary-800/80 bg-primary-900/60 p-4">
                  <p className="font-heading text-2xl font-extrabold text-background-50">
                    {stat.value}
                    <span className="ml-1 text-sm font-medium text-accent-400">{stat.suffix}</span>
                  </p>
                  <p className="mt-1 text-[11px] text-background-400">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-3 space-y-3">
              {features.map((feature) => (
                <div key={feature.title} className="flex items-start gap-3 rounded-lg bg-primary-900/40 p-3.5">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-800 text-accent-300">
                    <i className={`${feature.icon} text-base`} />
                  </span>
                  <div>
                    <p className="text-[13px] font-semibold text-background-50">{feature.title}</p>
                    <p className="mt-0.5 text-[11px] leading-relaxed text-background-400">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}